import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import {getAbout, getSite} from '../tools/fetcher';

export default function About({ className }) {
    const [abouts, setAbouts] = useState([]);
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        getAbout().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    title: d?.title?.rendered,
                    description: d?.about_details?.description,
                    imageSrc: d?.about_details?.image_src,
                    imageAlt: d?.about_details?.image_alt,
                    decorativeImageSrc: d?.about_details?.decorative_image_src,
                    decorativeImageAlt: d?.about_details?.decorative_image_alt,
                }));
                setAbouts(dt);
            }
        });
    }, []);

    return (
        <div className={classNames('auto-rows-min gap-10 grid grid-cols-1 sm:grid-cols-2', className)}>
            <div>
                <div className={'font-extrabold max-w-[500px] text-xs text-primary-green-100 tracking-[0.2em] sm:text-sm'}>
                    {data?.about?.title}
                </div>
                <div className={'font-bold max-w-[560px] mb-[44px] mx-1 text-[32px] text-primary-green-101 sm:text-[40px]'}>
                    {data?.about?.description}
                </div>
                {abouts.slice(0, 1).map((about, index) => (
                    <div key={index} className={'bg-white border border-primary-white-101 p-6 relative rounded-[20px] space-y-6 sm:p-10'}>
                        <img src={about.imageSrc}  alt={about.imageAlt} className={'h-[60px] w-[60px]'}/>
                        <div className={'space-y-2 z-20'}>
                            <p className={'font-bold leading-8 text-xl text-primary-green-101 z-10'}>{about.title.replace(/&#038;/g , "&")}</p>
                            <p className={'leading-7 text-base text-primary-gray-100'}>{about.description}</p>
                        </div>
                        <img src={about.decorativeImageSrc}  alt={about.decorativeImageAlt} className={'absolute hidden right-0 rounded-r-[20px] top-0 z-0'}/>
                    </div>
                ))}
            </div>
            <div className={'space-y-10'}>
                {abouts.slice(1, 3).map((about, index) => (
                    <div key={index} className={'bg-white border border-primary-white-101 p-6 relative rounded-[20px] space-y-6 sm:p-10'}>
                        <img src={about.imageSrc}  alt={about.imageAlt} className={'h-[60px] w-[60px]'}/>
                        <div className={'space-y-2 z-20'}>
                            <p className={'font-bold leading-8 text-xl text-primary-green-101 z-10'}>{about.title}</p>
                            <p className={'leading-7 text-base text-primary-gray-100'}>{about.description}</p>
                        </div>
                        <img src={about.decorativeImageSrc}  alt={about.decorativeImageAlt} className={'absolute hidden right-0 rounded-r-[20px] top-0 z-0'}/>
                    </div>
                ))}
            </div>
        </div>
    );
}
